import { render, staticRenderFns } from "./ModalEdicaoItemDeCertidao.vue?vue&type=template&id=7e1e1464"
import script from "./ModalEdicaoItemDeCertidao.vue?vue&type=script&lang=ts"
export * from "./ModalEdicaoItemDeCertidao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports